<template>
<div id="demo-basic-card">
  <vx-card class="box" style="margin-bottom:20px" v-if="defectExamList.length != 0" scrollHeight>
    <vs-collapse>
      <vs-collapse-item id='collapse'>
        <div slot="header" style="color:red">승인 보류 항목 ({{defectExamList.length}})</div>
        <div class="vx-row" style="padding:10px">
          <ExamItem v-for="(exam, index) in defectExamList" :examInfo="exam" @state="setExamState" :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
  <vx-card class="box" style="margin-bottom:20px" v-if="writingExamList" scrollHeight>
    <vs-collapse>
      <vs-collapse-item id='collapse'>
        <div slot="header">시험 작성 항목 ({{writingExamList.length}})</div>
        <div class="vx-row" style="padding:10px">
          <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
            <vx-card class="text-center" style="height:180px;">
              <div class="p-6 text-center">
                <div class="vx-row justify-center">
                  <vs-button color="dark" type="border" icon-pack="feather" icon="icon-plus" size="small" @click="createExam()" style="margin-top:20px; margin-right:10px;" />
                  <p class="text" style="margin-top:22px;" @click="createExam()"> 시험 추가 </p>
                </div>
              </div>
            </vx-card>
          </div>
          <ExamItem v-for="(exam, index) in writingExamList" :examInfo="exam" @state="setExamState" :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
    <!-- <vs-collapse  v-if="writingExamList.length == 0">
      <vs-collapse-item id='collapse' open>
        <div slot="header">작성 중인 시험</div>
        <div class="vx-row" style="padding:10px">
          <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
            <vx-card class="text-center" style="height:180px;">
              <div class="p-6 text-center">
                <div class="vx-row justify-center">
                  <vs-button color="dark" type="border" icon-pack="feather" icon="icon-plus" size="small" @click="createExam()" style="margin-top:20px; margin-right:10px;" />
                  <p class="text" style="margin-top:22px;" @click="createExam()"> 시험 추가 </p>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse> -->
  </vx-card>
  <vx-card class="box" style="margin-bottom:20px" v-if="scheduleExamList" scrollHeight>
    <vs-collapse>
      <vs-collapse-item id='collapse' >
        <div slot="header">승인 대기 항목 ({{scheduleExamList.length}})</div>
        <div class="vx-row" style="padding:10px">
          <ExamItem v-for="(exam, index) in scheduleExamList" :examInfo="exam" @state="setExamState" :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>

  <!-- <vx-card class="box" style="margin-bottom:20px">
    <vs-collapse>
      <vs-collapse-item id='collapse'>
        <div slot="header">진행 중인 시험</div>
        <div class="vx-row" style="padding:10px">
          <ExamItem v-for="(exam, index) in currentExamList" :examInfo="exam" :key="index" />
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card> -->
</div>
</template>

<script>
import ExamItem from './ExamItem.vue'

export default {
  components: {
    'ExamItem':ExamItem,
  },
  data() {
    return {
      title: 'AClass',
      workspacePopup: false,
      examInfo: {
        'id': 0,
        'start_time': null,
        'end_time': null,
        'info': 'high',
        'grade': '1',
        'test_name': '',
        'institute': '',
        'state': 0,
        'release_time': '',
        'exam_version': '',
        'total_score': 0
      }
    }
  },
  created() {
    this.$store.dispatch('etest/getEtestExam', 'writing')
      .then(() => {
        this.$store.dispatch('etest/getEtestExam', 'defect').then(()=>{
          this.$store.dispatch('etest/getEtestExam', 'schedule')
        })
      })
    // this.$store.dispatch('etest/getEtestExam', 'current')

  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    writingExamList() {
      return this.$store.state.etest.writingExamList
    },
    scheduleExamList() {
      return this.$store.state.etest.scheduleExamList
    },
    currentExamList() {
      return this.$store.state.etest.currentExamList
    },
    defectExamList(){
      return this.$store.state.etest.defectExamList
    }
  },
  methods: {
    setExamState(val) {
      this.$store.dispatch('etest/updateExamState', {
        'id': val.exam_id,
        'state':val.state
      }).then(()=> {
        this.$store.dispatch('etest/getEtestExam', 'writing').then(()=> {
          this.$store.dispatch('etest/getEtestExam', 'defect').then(()=>{
            this.$store.dispatch('etest/getEtestExam', 'schedule')
          })
        })
      })
    },
    createExam() {
      this.$store.commit('etest/ACTIVE_EXAML', this.examInfo)
      this.$router.push('/apps/etest/editer/0')
    },
  }
}
</script>


<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 705px;
        }
    }
}
</style>
